<template>
  <div class="member-list">
    <div class="search-bar">
      <van-search
        v-model="searchText"
        placeholder="请输入搜索关键词"
        show-action
        left-icon=""
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div
        class="push-list"
        @click="goToPushTaskList"
      >
        推送列表
      </div>
    </div>
    <div class="member-list-category">
      <van-field
        readonly
        clickable
        name="picker"
        :value="categoryValue"
        label=""
        placeholder="点击选择分类"
        @click="showCategoryPicker = true"
        right-icon="arrow-down"
      >
        <template #input>
          <div class="category-item">
            <van-icon :name="categoryColumns.find(item => item.value === categoryValue).icon" />
            {{ categoryColumns.find(item => item.value === categoryValue).text }}
          </div>
        </template>
      </van-field>
      <van-popup
        v-model="showCategoryPicker"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="categoryColumns"
          @confirm="onCategoryConfirm"
          @cancel="showCategoryPicker = false"
        >
          <template #option="option">
            <div class="category-item">
              <van-icon :name="option.icon" />
              {{ option.text }}
            </div>
          </template>
        </van-picker>
      </van-popup>
    </div>

    <div class="member-container">

      <van-cell
        v-for="member in filteredMembers"
        :key="member.id"
      >
        <template #title>
          <div class="member-item">
            <div class="member-info">
              <img
                round
                width="40"
                height="40"
                :src="member.avatar"
              />
              <span class="member-name">{{ member.name }}</span>
            </div>

            <div class="member-actions">
              <van-icon
                name="bookmark-o"
                color="#000"
                @click="showGroupDialog(member)"
              />
              <van-icon
                :name="member.favorite_status ? 'star' : 'star-o'"
                :class="{ 'favorite': member.favorite_status }"
                @click="memberCollect(member)"
              />

              <van-checkbox
                v-model="member.isSelected"
                :name="member.id"
                shape="square"
                @click="toggleMember(member)"
              >

              </van-checkbox>
            </div>

          </div>
        </template>
      </van-cell>
    </div>
    <div class="member-list-selected">
      已选择：{{ selectedMembers.map((m) => m.name).join(",") }}
    </div>

    <el-button
      type="primary"
      @click="onSendMessage"
    >发送消息</el-button>

    <!-- 群组分配弹窗 -->
    <van-popup
      v-model="showGroupAssign"
      position="bottom"
      round
      closeable
      :style="{ height: '60%' }"
    >
      <div class="group-assign-popup">
        <div class="popup-header">
          <div class="popup-title">分配群组</div>
          <van-search
            v-model="groupSearchText"
            placeholder="搜索群组"
            shape="round"
            class="group-search"
          />
        </div>

        <van-checkbox-group
          v-model="selectedGroups"
          class="group-list"
        >
          <van-cell-group>
            <van-cell
              v-for="group in filteredGroups"
              :key="group.id"
              :title="group.name"
              clickable
              @click="toggleGroup(group.id)"
            >
              <template #right-icon>
                <van-checkbox
                  :name="group.id"
                  @click.stop
                />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>

        <div class="popup-footer">
          <el-button
            block
            type="primary"
            @click="assignGroups"
          >
            确认分配
          </el-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import wecomAPI from "@/apis/wecom";
import { Toast } from "vant";

export default {
  name: "MemberList",

  data() {
    return {
      searchText: "",
      allMembers: [],
      members: [],
      selectedMembers: [],
      showGroupAssign: false,
      currentMember: null,
      selectedGroups: [],
      categoryValue: "all",
      showCategoryPicker: false,
      groupList: [],
      categoryColumns: [
        {
          text: "全部",
          value: "all",
          icon: "chat-o",
        },
        {
          text: "单聊",
          value: "single",
          icon: "manager-o",
        },
        {
          text: "群聊",
          value: "group",
          icon: "friends-o",
        },
        {
          text: "星标",
          value: "star",
          icon: "star-o",
        },
      ],
      groupSearchText: "",
    };
  },

  computed: {
    filteredMembers() {
      if (!this.searchText) return this.members;
      const searchLower = this.searchText.toLowerCase();
      return this.members.filter((member) =>
        member.name.toLowerCase().includes(searchLower)
      );
    },
    filteredGroups() {
      if (!this.groupSearchText) return this.groupList;
      const searchLower = this.groupSearchText.toLowerCase();
      return this.groupList.filter((group) =>
        group.name.toLowerCase().includes(searchLower)
      );
    },
  },

  created() {
    this.fetchMembers();
    this.fetchGroupList();
  },

  methods: {
    toggleMember(member) {
      if (member.isSelected) {
        this.selectedMembers.push(member);
      } else {
        this.selectedMembers = this.selectedMembers.filter(
          (m) => m.id !== member.id
        );
      }
    },
    async onCategoryConfirm(value) {
      this.categoryValue = value.value;
      this.showCategoryPicker = false;

      // 根据不同分类筛选成员
      if (this.categoryValue === "all") {
        this.members = this.allMembers;
      } else if (this.categoryValue === "single") {
        this.members = this.allMembers.filter((member) => member.type === 1);
      } else if (this.categoryValue === "group") {
        this.members = this.allMembers.filter((member) => member.type === 2);
      } else if (this.categoryValue === "star") {
        this.members = this.allMembers.filter(
          (member) => member.favorite_status === 1
        );
      } else {
        // 如果是群组ID，则筛选属于该群组的成员
        const groupId = parseInt(this.categoryValue);
        if (!isNaN(groupId)) {
          this.members = this.allMembers.filter(
            (member) =>
              member.groups &&
              member.groups.some((group) => group.id === groupId)
          );
        }
      }

      // 重置搜索文本
      //   this.searchText = "";
    },
    async fetchMembers() {
      try {
        const params = {
          filter: this.searchText || "",
        };
        const data = await wecomAPI.getMemberList(params);
        this.allMembers = data;
        this.members = data;
      } catch (error) {
        Toast("获取成员列表失败");
      }
    },

    onSearch() {
      // 触发搜索时的额外操作（如有需要）
      this.members = this.allMembers.filter((member) =>
        member.name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    },

    toggleFavorite(member) {
      member.favorite_status = !member.favorite_status;
    },

    showGroupDialog(member) {
      this.currentMember = member;
      // 初始化选中的群组为当前成员已有的群组
      this.selectedGroups = member.groups
        ? member.groups.map((group) => group.id)
        : [];
      this.groupSearchText = ""; // 重置搜索文本
      this.showGroupAssign = true;
    },

    toggleGroup(groupId) {
      const index = this.selectedGroups.indexOf(groupId);
      if (index > -1) {
        this.selectedGroups.splice(index, 1);
      } else {
        this.selectedGroups.push(groupId);
      }
    },

    async assignGroups() {
      if (!this.currentMember) return;

      try {
        Toast.loading({
          message: "分配中...",
          forbidClick: true,
        });

        await wecomAPI.assignMemberGroup({
          id: this.currentMember.id,
          type: this.currentMember.type,
          group_ids: this.selectedGroups,
        });

        Toast.success("群组分配成功");
        this.showGroupAssign = false;
        await this.fetchMembers(); // 刷新列表
      } catch (error) {
        Toast.fail("群组分配失败");
      }
    },

    onSendMessage() {
      if (this.selectedMembers.length === 0) {
        Toast("请选择至少一个成员");
        return;
      }

      this.$router.push({
        name: "MessageSend",
        query: {
          members: JSON.stringify(
            this.selectedMembers.map((m) => ({
              id: m.id,
              name: m.name,
              // avatar: m.avatar,
              type: m.type,
            }))
          ),
        },
      });
    },
    // 收藏
    async memberCollect(member) {
      await wecomAPI.memberCollect({
        id: member.id,
        type: member.type,
        favorite_status: member.favorite_status ? 0 : 1,
      });
      member.favorite_status = !member.favorite_status;
    },
    // 获取分组列表
    async fetchGroupList() {
      try {
        // 这里需要添加获取分组列表的接口
        const data = await wecomAPI.getGroupList();

        this.groupList = data;
        this.categoryColumns.push(
          ...data.map((item) => ({
            text: item.name,
            value: item.id,
            icon: "group-o",
          }))
        );
      } catch (error) {
        Toast("获取分组列表失败");
      }
    },
    goToPushTaskList() {
      this.$router.push({
        name: "PushTaskList",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.member-list {
  height: calc(100vh - 20px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;

  .search-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .van-search {
    background-color: transparent;
    flex: 1;
    .van-search__action {
      color: #fff;
    }
  }
  .push-list {
    width: 40px;
    margin-left: 10px;
    text-align: center;
    color: #fff;
  }

  .member-container {
    flex: 1;
    overflow-y: auto;
  }
  .member-list-category {
    width: auto;
    ::v-deep .van-field__control {
      color: #fff;
    }
    .van-cell {
      width: auto;
    }
  }

  .member-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;

    .member-info {
      display: flex;
      align-items: center;
      gap: 12px;

      .member-name {
        font-size: 14px;
        color: #000;
      }
    }

    .member-actions {
      display: flex;
      gap: 30px;

      .van-icon {
        font-size: 20px;
        color: #666;

        &.favorite {
          color: #ff9800;
        }
      }
    }
  }
}
.member-list-selected {
  padding: 10px;
  color: #002d5c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-button--primary {
  background-color: #002d5c;
  border-color: #002d5c;
}
.group-assign-popup {
  display: flex;
  flex-direction: column;
  height: 100%;

  .popup-header {
    padding: 16px 16px 0;

    .popup-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 12px;
      text-align: center;
    }

    .group-search {
      margin-bottom: 8px;
    }
  }

  .group-list {
    flex: 1;
    overflow-y: auto;
  }

  .popup-footer {
    padding: 16px;
    background-color: #fff;
    border-top: 1px solid #eee;
    .el-button {
      width: 100%;
    }
  }
}
</style> 